import { render } from "./modal-detail-topup-manual.vue?vue&type=template&id=167cb996&scoped=true&ts=true"
import script from "./modal-detail-topup-manual.vue?vue&type=script&lang=ts"
export * from "./modal-detail-topup-manual.vue?vue&type=script&lang=ts"

import "./modal-detail-topup-manual.vue?vue&type=style&index=0&id=167cb996&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-167cb996"]])

export default __exports__